export const CHAIN_BRANCH_LOCATOR_SOURCE_KEYS = Object.freeze({
  EXITO: "EXITO_BRANCH_LOCATOR",
  CARULLA: "CARULLA_BRANCH_LOCATOR",
  JUMBO: "JUMBO_BRANCH_LOCATOR",
  OLIMPICA: "OLIMPICA_BRANCH_LOCATOR",
  D1: "D1_BRANCH_LOCATOR",
  ARA: "ARA_BRANCH_LOCATOR",
});

export const FOOD_MAP_SOURCE_FILTERS = Object.freeze({
  ALL: "ALL",
  OSM: "OSM",
  CHAIN_LOCATOR: "CHAIN_LOCATOR",
});
